export default __webpack_public_path__ + "static/media/3071.6dca1244.jpg";